/* ======================================================================== */
/* 22. Cursor */
/* ======================================================================== */
var Cursor = function () {

	var
		self = this,
		$cursor = $('#js-cursor');

	this.drawLoading = function () {
		window.$body.addClass('cursor-progress');
		drawLoading();
	};

	this.finishLoading = function () {
		window.$body.removeClass('cursor-progress');
		finishLoading();
	};

	this.mouseX = 0;
	this.mouseY = 0;

	this.update = function () {
		self.mouseX = self.mouseX + pageXOffset;
		self.mouseY = self.mouseY + pageYOffset;
	}

	// don't launch on mobiles
	if (!$cursor.length || Modernizr.touchevents) {
		return;
	}

	var
		tl = new TimelineMax(),
		$follower = $('.cursor__follower'),
		$inner = $follower.find('#inner'),
		$outter = $follower.find('#outter'),
		$cursorArrowLeft = $cursor.find('.cursor__arrow_left'),
		$cursorArrowRight = $cursor.find('.cursor__arrow_right'),
		offset = parseInt(window.$html.css('marginTop'), 10),
		posX = 0,
		posY = 0,
		hideCursorElements = [
			'.slider__arrow',
			'.slider__dot',
			'.social__item a',
			'.section-video__link',
			'.grid__item-link',
			'.section-nav-projects__inner'
		];

	start();

	function start() {

		if (!$cursor.length || Modernizr.touchevents) {
			return;
		}

		TweenMax.set($cursor, {
			display: 'block',
			y: '-50%',
			x: '-50%'
		});

		TweenMax.to({}, 0.01, {
			repeat: -1,
			onRepeat: function () {

				posX += (self.mouseX - posX) / 6;
				posY += (self.mouseY - posY - offset) / 6;

				TweenMax.set($cursor, {
					x: posX,
					y: posY + offset,
				});

			}
		});

		TweenMax.set($outter, {
			drawSVG: '0%',
		});

		$document.on('mousemove', function (e) {
			self.mouseX = e.clientX;
			self.mouseY = e.clientY;
		});

		$document.on('mouseenter', 'a, #js-burger, #js-submenu-back', function () {

			TweenMax.to($cursor, 1.2, {
				scale: 1.5,
				ease: Elastic.easeOut.config(1, 0.4),
			});

			TweenMax.to($inner, 0.6, {
				opacity: 1
			});

		})
			.on('mouseleave', 'a, #js-burger, #js-submenu-back', function () {

				TweenMax.to($cursor, 1.2, {
					scale: 1,
					ease: Elastic.easeOut.config(1, 0.4),
				});

				TweenMax.to($inner, 0.6, {
					opacity: .6
				});

			});

		$document.on('mouseenter', hideCursorElements.join(','), function () {

			TweenMax.to($cursor, 0.3, {
				scale: 0,
				ease: Expo.easeInOut
			});

			TweenMax.to($inner, 0.3, {
				opacity: 1
			});

		})
			.on('mouseleave', hideCursorElements.join(','), function () {

				TweenMax.to($cursor, 1.2, {
					scale: 1,
					ease: Elastic.easeOut.config(1, 0.4),
				});

				TweenMax.to($inner, 0.6, {
					opacity: .6,
				});

			});

		// draggable slider arrows
		$document.on('mouseenter', '.slider_draggable', function () {
			TweenMax.to($cursorArrowLeft, 0.3, {
				autoAlpha: 1,
				x: -20
			});;
			TweenMax.to($cursorArrowRight, 0.3, {
				autoAlpha: 1,
				x: 20
			});
		}).on('mouseleave', '.slider_draggable', function () {
			TweenMax.to([$cursorArrowLeft, $cursorArrowRight], 0.3, {
				autoAlpha: 0,
				x: 0
			});
		});

	}

	function drawLoading() {

		if (!$cursor.length || Modernizr.touchevents) {
			return;
		}

		tl
			.stop().clear().play()
			.add(TweenMax.to($cursor, 1.2, {
				scale: 1.5,
				ease: Elastic.easeOut.config(1, 0.4)
			}))
			.fromTo($outter, 3, {
				drawSVG: '0%',
				ease: Expo.easeInOut
			}, {
				drawSVG: '100%',
				ease: Expo.easeInOut
			}, '0');

	}

	function finishLoading() {

		if (!$cursor.length || Modernizr.touchevents) {
			return;
		}

		tl.stop().clear().play()
			.to($outter, 0.6, {
				drawSVG: '100%',
				ease: Expo.easeInOut
			})
			.to($outter, 0.3, {
				autoAlpha: 0
			})
			.set($outter, {
				drawSVG: '0%',
				autoAlpha: 1
			})
			.to($cursor, 1.2, {
				scale: 1,
				ease: Elastic.easeOut.config(1, 0.4),
			});

	}

}
